"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _GroupTitle = _interopRequireDefault(require("./GroupTitle"));
var _GroupList = _interopRequireDefault(require("./GroupList"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

/**
 * Class renders a group of Link elements as child nodes.
 */
class LinkGroup extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      styles: {
        height: '75px',
        overflow: 'hidden',
        padding: '0',
        float: 'left',
        border: 'none'
      },
      listOpen: false,
      id: this.props.group.title.text.toLowerCase().replace(/\s+/, '')
    };
  }
  handleListEnter() {
    this.setState({
      styles: {
        height: 'auto',
        overflow: 'visible',
        color: '#fff',
        padding: '0',
        float: 'left'
      },
      isEntered: true
    });
  }
  handleListLeave() {
    this.setState({
      styles: {
        height: '75px',
        overflow: 'hidden',
        padding: '0',
        float: 'left'
      },
      isEntered: false
    });
  }
  toggleOpen() {
    this.props.handleLinkGroups(this.state.id);
  }
  render() {
    let listOpen = false;

    // const listOpen = this.props.groupLinks[this.state.id] ? this.props.groupLinks[this.state.id].isOpen : false;
    // Removes uncessary undefined group links and empty objects. Since this is set on render
    // there are quite a few of them
    if (Object.keys(this.props.groupLinks).length > 0 && this.props.groupLinks[this.state.id]) {
      listOpen = this.props.groupLinks[this.state.id].isOpen;
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      className: 'header-link-group',
      onMouseEnter: this.handleListEnter.bind(this),
      onMouseLeave: this.handleListLeave.bind(this),
      style: !this.props.isMobile ? this.state.styles : null
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        padding: '0',
        position: 'relative',
        cursor: 'pointer'
      }
    }, /*#__PURE__*/_react.default.createElement(_GroupTitle.default, {
      title: this.props.group.title.text,
      href: this.props.group.title.src,
      className: this.props.group.title.className,
      listOpen: listOpen,
      isOpen: this.state.isOpen,
      isMobile: this.props.isMobile,
      toggleOpen: this.toggleOpen.bind(this)
    }), this.state.isEntered && !this.props.isMobile ? /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-item-border",
      style: {
        marginTop: '-5px',
        borderBottom: '5px solid #f0ab00',
        width: '100%',
        cursor: 'pointer'
      }
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-item-border"
    }), /*#__PURE__*/_react.default.createElement(_GroupList.default, {
      list: this.props.group.list,
      listOpen: listOpen,
      isMobile: this.props.isMobile
    })));
  }
}
exports.default = LinkGroup;
LinkGroup.propTypes = {
  group: _propTypes.default.object,
  count: _propTypes.default.number,
  isMobile: _propTypes.default.bool,
  groupLinks: _propTypes.default.object,
  handleLinkGroups: _propTypes.default.func
};